function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useRef } from 'react';
import getResource from "../../services/resources";
import { t } from "../../services/translator";
import storage from "../../services/storage";
import logger from "../../services/logger";
import { Context } from "../../services/context";
import { Row, Col, Button, Spinner } from 'reactstrap';
import LanguageChoice from "../common/language-choice";
import Logo from "../../assets/img/logo.png";
var styleContainer = {
  width: '50%',
  minHeight: '450px'
};
export default (function (_ref) {
  var alias = _ref.alias;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      cookie = _useState2[0],
      setCookie = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  var iframeRef = useRef();

  var _useContext = useContext(Context),
      update = _useContext.update,
      locale = _useContext.locale;

  var disableCookie = function disableCookie() {
    setShow(false);
    update({
      isCookieValidated: true
    });
  };

  var loadCookie = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var formatedLocale, cookieApi;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formatedLocale = locale;

              if (locale && locale.indexOf('-') !== -1) {
                formatedLocale = locale.substr(0, locale.indexOf('-'));
              }

              _context.next = 4;
              return getResource('Cookie').public(alias, formatedLocale);

            case 4:
              cookieApi = _context.sent;
              setCookie(cookieApi);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadCookie() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleAccept = function handleAccept() {
    storage.storage_name = 'cookie_acceptation';
    storage.set(alias, {
      value: true,
      createdAt: new Date()
    });
    storage.storage_name = 'wever_app';
    disableCookie();
  };

  var handleReloadCookie = function handleReloadCookie() {
    document.addEventListener('reload_cookie', function () {
      setShow(true);
      loadCookie();
    });
  };

  var resizeIframe = function resizeIframe() {
    var obj = iframeRef.current;

    if (!obj) {
      return;
    }

    obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
  };

  useEffect(function () {
    handleReloadCookie();
  }, []);
  useEffect(function () {
    storage.storage_name = 'cookie_acceptation';
    var isAccepted = storage.get(alias);
    storage.storage_name = 'wever_app';

    if (isAccepted && isAccepted.value) {
      disableCookie();
      return;
    }

    loadCookie();
  }, []);

  if (!show || !alias) {
    logger.info('No cookie', '', {
      show: show,
      alias: alias
    });
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-items-center cookie-body",
    style: {
      height: '100vh',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(LanguageChoice, null), /*#__PURE__*/React.createElement("div", {
    className: "cookie-container",
    style: styleContainer
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mt-3 mb-4"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-center align-items-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: Logo,
    height: "60",
    alt: "wever"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "m-0"
  }, cookie ? /*#__PURE__*/React.createElement(Col, {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("iframe", {
    ref: iframeRef,
    title: "consent",
    id: "cookie-frame",
    onLoad: function onLoad() {
      return resizeIframe.apply(void 0, arguments);
    },
    srcDoc: cookie.content,
    style: {
      width: '100%',
      height: 'auto'
    }
  })) : /*#__PURE__*/React.createElement(Spinner, {
    color: "danger"
  }), /*#__PURE__*/React.createElement(Col, {
    className: "col-12 mt-3 py-2 d-flex justify-content-center align-items-centers"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "danger",
    size: "sm",
    className: "mx-2 rounded-pill",
    onClick: handleAccept
  }, t('core_accept_cookie'))))));
});